import { render, staticRenderFns } from "./AngsuranKumpulan.vue?vue&type=template&id=95081940&scoped=true"
import script from "./AngsuranKumpulan.vue?vue&type=script&lang=js"
export * from "./AngsuranKumpulan.vue?vue&type=script&lang=js"
import style0 from "./AngsuranKumpulan.vue?vue&type=style&index=0&id=95081940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95081940",
  null
  
)

export default component.exports